module.exports = __webpack_public_path__ + "static/media/bkg_textos.510148da.jpg";